// NOTE: This source is not exactly the same as the code here. Use with caution.
// Source: https://play.tailwindcss.com/m5wRcqouZ7?size=540x720&file=css

const FIELD = {
  ".ds-field": {
    "@apply ds-relative ds-bg-primary-white ds-inline-block ds-min-w-full md:ds-w-auto md:ds-min-w ds-h-[52px]": true,
  },
  ".ds-field > .ds-icon,\n.ds-field > .ds-tooltip": {
    "@apply ds-absolute ds-right ds-top-sm ds-z-10": true,
  },
  ".ds-field > .ds-icon:focus,\n.ds-field > .ds-icon:hover,\n.ds-field > .ds-tooltip:focus .ds-icon,\n.ds-field > .ds-tooltip:hover .ds-icon":
    {
      "@apply before:!ds-bg-primary-blue ds-text-primary-blue": true,
    },
  ".ds-field input,\n.ds-field textarea": {
    "@apply ds-w-full md:ds-min-w ds-align-top ds-relative ds-z-10 ds-border ds-inline-block ds-rounded-md ds-border-tertiary-lightgrey ds-bg-transparent ds-h-auto ds-min-h-[52px]": true,
  },
  ".ds-field input,\n.ds-field textarea,\n.ds-field label": {
    "@apply ds-font-regular ds-text-xl ds-px-lg ds-py-[10px]": true,
  },
  ".ds-field input:hover,\n.ds-field input:focus,\n.ds-field textarea:hover,\n.ds-field textarea:focus": {
    "@apply ds-border-tertiary-mediumgrey ds-outline-none": true,
  },
  ".ds-field label": {
    "@apply ds-text-tertiary-darkgrey ds-absolute ds-left-0 ds-rounded-sm ds-z-0 ds-transition-all ds-leading-[30px]": true,
  },
  ".ds-field input:focus ~ label,\n.ds-field input:not(:placeholder-shown) ~ label,\n.ds-field textarea:focus ~ label,\n.ds-field textarea:not(:placeholder-shown) ~ label":
    {
      "@apply ds-bg-primary-white ds-text-primary-blue ds-text-sm ds-font-medium ds-p-2xs ds-top-[-9px] ds-left-lg ds-leading-[10px] ds-z-10": true,
    },
  ".ds-field.ds-fluid,\n.ds-field.ds-fluid input,\n.ds-field.ds-fluid textarea": {
    "@apply ds-min-w-full": true,
  },
  ".ds-field.ds-valid label": { "@apply !ds-text-secondary-green": true },
  ".ds-field.ds-valid input,\n.ds-field.ds-valid textarea": {
    "@apply ds-border-secondary-green-70": true,
  },
  ".ds-field.ds-valid input:hover,\n.ds-field.ds-valid textarea:hover": {
    "@apply ds-border-secondary-green": true,
  },
  ".ds-field.ds-invalid label": { "@apply !ds-text-secondary-red": true },
  ".ds-field.ds-invalid input,\n.ds-field.ds-invalid textarea": {
    "@apply ds-border-secondary-red-70": true,
  },
  ".ds-field.ds-invalid input:hover,\n.ds-field.ds-invalid textarea:hover": {
    "@apply ds-border-secondary-red": true,
  },
  ".ds-field input:disabled,\n.ds-field textarea:disabled": {
    "@apply !ds-border-tertiary-lightgrey !ds-bg-background-grey !ds-text-tertiary-mediumgrey": true,
  },
  ".ds-field input:disabled ~ label,\n.ds-field textarea:disabled ~ label": {
    "@apply !ds-text-tertiary-mediumgrey ds-z-20": true,
  },
  ".ds-field input[readonly],\n.ds-field textarea[readonly]": {
    "@apply ds-border-tertiary-lightgrey": true,
  },
};

// TODO (stefan): Make this global
// When exporting a Tailwind CSS to JavaScript using this tool: https://transform.tools/css-to-js
// we also need to remove the prefix (ds) before we can use it inside our config.
// This utility function solves that problem.
// We might consider turning this into a global utility if we want to use it in more components
// in the future.
const parseKeys = (source) => {
  const target = {};
  for (const sourceKey in source)
    if (typeof source[sourceKey] === "object") {
      const targetKey = sourceKey.replace(/\.ds-/g, ".").replace(/\n/, "");
      target[targetKey] = parseKeys(source[sourceKey]);
    } else target[sourceKey] = source[sourceKey];
  return target;
};

module.exports = () => parseKeys(FIELD);
